module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_5012.2f8bae20.png";